/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/**
 * Returns the portlet Id extracted from the provided portletId query parameter
 * @param {!string} portletId The portletId query parameter to extract the portletId from in the form of `_p_p_id_portletId_`
 * @return {string} Portlet ID
 * @review
 */
const REGEX_PORTLET_ID = /^(?:p_p_id)?_(.*)_.*$/;

export default function getPortletId(portletId) {
	return portletId.replace(REGEX_PORTLET_ID, '$1');
}
